import React, { useState, useRef, useEffect } from 'react';
import './scheduledmeetings.scss';
import { ReactComponent as Zoom } from '../../images/zoomlogo.svg';
import { ReactComponent as Callback } from '../../images/schedule.svg';
import { ReactComponent as CloseIcon } from '../../images/Close.svg';
import Modal from '../../components/Modal/Modal';
import { AiFillInfoCircle } from 'react-icons/ai';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';
import { useCallback } from 'react';
import base from '../../apis';
import { toast } from 'react-toastify';
import Spinner from '../../components/Spinner/Spinner';
import { getCallStatus } from '../../utils/functions';
import Toggle from 'react-toggle';
import { ReactComponent as Avatar } from '../../images/avatarDefault.svg';
import Input from '../../components/Input/Input';
import { useSelector } from 'react-redux';

function ScheduledMeetings() {
  const [selectedDate, setSelectedDate] = useState(0);
  const [selectedTask, setSelectedTask] = useState(null);
  const [reassignModal, setReassignModal] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const dates = [];

  for (let i = 0; i < 14; i++) {
    dates.push({
      display: new Date(new Date().setDate(new Date().getDate() + i))
        .toLocaleDateString('en', {
          weekday: 'short',
          day: 'numeric',
        })
        .replace(',', '')
        .split(' '),
      value: new Date().setDate(new Date().getDate() + i),
    });
  }

  const [morning, setMorning] = useState([]);
  const [afternoon, setAfternoon] = useState([]);

  const dateHolder = useRef(dates);
  const ORIGINAL_TASKS = useRef([]);
  const [tasks, setTasks] = useState([]);
  const [marketers, setMarketers] = useState([]);
  const ORIGINAL_MARKETERS = useRef([]);
  const [isLoading, setIsLoading] = useState(false);
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);

  const doCalcs = (date, CB = true, SZ = true) => {
    setMorning([]);
    setAfternoon([]);
    setTasks([]);
    let todays = ORIGINAL_TASKS.current.filter(
      (item) => new Date(item.next_call).toJSON().slice(0, 10) === new Date(date).toJSON().slice(0, 10)
    );
    if (!CB) {
      todays = todays.filter((item) => item.call_status !== 'CB');
    }
    if (!SZ) {
      todays = todays.filter((item) => item.call_status !== 'SZ');
    }
    if (todays.length === 0) {
      toast.warn('No scheduled meetings selected day', { toastId: 'noScheduledMeetings' });
    }

    const morning = todays.filter((item) => new Date(item.next_call).toJSON().slice(11, 13) < 12);
    const afternoon = todays.filter((item) => new Date(item.next_call).toJSON().slice(11, 13) >= 12);
    setMorning(morning);
    setAfternoon(afternoon);
    setTasks(todays);
  };

  const marketing_team_id = useSelector((state) => state.auth.marketerDetails.team_id);
  useEffect(() => {
    if (!marketing_team_id) {
      toast.error('You have not been assigned to a team. Please contact the administrator.', { toastId: 'noteam' });
    }
  }, [marketing_team_id]);

  const getData = useCallback(() => {
    if (!marketing_team_id) {
      return;
    }
    const urls = [
      `/operations/marketing_teams/${marketing_team_id}/tasks/`,
      `/operations/marketing_teams/${marketing_team_id}/`,
    ];
    setIsLoading(true);
    setSelectedDate(0);
    Promise.all(urls.map((endpoint) => base.get(endpoint)))
      .then((data) => {
        const members = data[1].data?.members;
        ORIGINAL_MARKETERS.current = members;
        setMarketers(members);
        const taskstoCheck = data[0].data?.filter((item) => ['SZ', 'CB'].includes(item.call_status));
        if (taskstoCheck.length === 0) {
          toast.warn('No scheduled meetings', { toastId: 'noScheduledMeetings' });
        }
        if (members.length === 0) {
          toast.error('No members found');
          //navigate to marketing exec team
        }

        ORIGINAL_TASKS.current = taskstoCheck.filter((item) => item.next_call);
        const tasks = ORIGINAL_TASKS.current;
        setMorning([]);
        setAfternoon([]);
        setTasks([]);
        let todays = tasks.filter(
          (item) => new Date(item.next_call).toJSON().slice(0, 10) === new Date().toJSON().slice(0, 10)
        );
        if (todays.length === 0) {
          toast.warn('No scheduled meetings for today');
        }
        const morning = todays.filter((item) => new Date(item.next_call).toJSON().slice(11, 13) < 12);
        const afternoon = todays.filter((item) => new Date(item.next_call).toJSON().slice(11, 13) >= 12);

        setMorning(morning);
        setAfternoon(afternoon);
        setTasks(todays);
      })
      .catch((err) => {
        toast.error('Could not get tasks ');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [marketing_team_id]);

  useEffect(() => {
    getData();
  }, [getData, marketing_team_id]);

  const [filters, setFilters] = useState({ CB: true, SZ: true });

  const onFilter = (e) => {
    const { name, checked } = e.target;
    const bod = { ...filters };
    if (name === 'CB' && !checked) bod['SZ'] = true;
    if (name === 'SZ' && !checked) bod['CB'] = true;
    bod[name] = checked;
    setFilters(bod);
    doCalcs(dateHolder.current[selectedDate].value, bod.CB, bod.SZ);
  };

  const handleClick = (item) => {
    setDetailsModalOpen(true);
    setSelectedTask(item);
  };
  const closeAll = () => {
    setIsLoading(true);
    base
      .patch(`/operations/tasks/${selectedTask.id}/`, {
        reassigned: true,
        marketer_id: selectedMarketer.id,
      })
      .then((data) => {
        setConfirmationModal(false);
        setReassignModal(false);
        setDetailsModalOpen(false);
        toast.success('Task reassigned successfully');
        getData();
      })
      .catch((err) => {
        toast.error('Could not reassign task');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const onDateChange = (i, date) => {
    setSelectedDate(i);
    setFilters({ CB: true, SZ: true });
    doCalcs(date);
  };

  const onSearchMarketers = (e) => {
    const { value } = e.target;
    setMarketers(
      ORIGINAL_MARKETERS.current.filter((item) =>
        `${item.user.first_name + item.user.last_name}`.toLowerCase().includes(value.toLowerCase())
      )
    );
  };

  const [selectedMarketer, setSelectedMarketer] = useState(null);
  const onSelectReplacement = (marketer) => {
    setConfirmationModal(true);
    setSelectedMarketer(marketer);
  };

  const onOpenReassign = () => {
    if (marketers.length === 1) {
      toast.warn('No other marketers to assign to');
      return;
    }
    setReassignModal(true);
  };

  return (
    <>
      {isLoading && <Spinner />}
      <ConfirmationModal
        text={`You are reassigning this scheduled meeting to ${selectedMarketer?.user.first_name} ${selectedMarketer?.user.last_name}`}
        open={confirmationModal}
        onCancel={() => setConfirmationModal(false)}
        onConfirm={closeAll}
        style={{ width: '40vw', minWidth: 'unset' }}
        office={selectedTask?.office.branch}
        location={selectedTask?.office.address}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderRadius: '5px',
            backgroundColor: selectedTask?.call_status === 'SZ' ? '#1378A5' : '#D2EFDA',
            color: selectedTask?.call_status === 'SZ' ? '#0a4057' : '#34A853',
            width: '100%',
            padding: '20px',
            boxShadow: '-2px 2px 10px 0px #00000026',
          }}>
          {selectedTask?.type === 'zoom' ? <Zoom /> : <Callback />}
          <span>
            {selectedTask?.agent_first_name} {selectedTask?.agent_last_name}
          </span>
          <span>
            {new Date(selectedTask?.next_call).toLocaleString('en', {
              weekday: 'short',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              month: 'short',
              year: 'numeric',
            })}
          </span>
          {/* <span>Time Frame</span> */}
        </div>
      </ConfirmationModal>
      <Modal open={reassignModal} onClose={() => setReassignModal(false)} style={{ width: '70vw' }}>
        <div className="mod2 mod3">
          <div className="mod2header mod3header" style={{ backgroundColor: 'white', position: 'sticky', top: 0 }}>
            <div className="header_info">
              <Input
                style={{
                  padding: '10px',
                  margin: 'unset',
                  marginLeft: 'auto',
                }}
                fullStyles={{
                  margin: 'unset',
                  marginLeft: 'auto',
                }}
                type="search"
                onChange={onSearchMarketers}
                placeholder="Search for Marketer"
              />
            </div>
            <CloseIcon
              className="close_icon"
              onClick={() => {
                setReassignModal(false);
              }}
              style={{ fill: '#1378A5', cursor: 'pointer' }}
              width="36px"
              height="18px"
            />
          </div>
          <div
            className="itemholder"
            style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', maxHeight: '50vh', overflowY: 'auto' }}>
            {selectedTask &&
              marketers
                .filter((el) => el.id !== selectedTask?.marketer.id)
                .map((item) => (
                  <AgentItem
                    key={item.id}
                    onClick={() => onSelectReplacement(item)}
                    name={item.user.first_name + ' ' + item.user.last_name}
                  />
                ))}
          </div>
        </div>
      </Modal>

      <Modal open={detailsModalOpen} onClose={() => setDetailsModalOpen(false)} style={{ minWidth: '70vw' }}>
        <div className="mod2" style={{ maxWidth: '70vw' }}>
          <div
            className="mod2header"
            style={{
              background: selectedTask?.call_status === 'CB' ? '#D2EFDA' : '#D1F1FF',
            }}>
            <div>
              <p>{selectedTask?.office?.branch}</p>
              <p>{selectedTask?.office?.address}</p>
            </div>
            <CloseIcon
              onClick={() => setDetailsModalOpen(false)}
              style={{ fill: '#1378A5', cursor: 'pointer' }}
              width="18px"
              height="18px"
            />{' '}
          </div>
          <div className="contholder">
            <div>
              <p>
                Agent's Name:{' '}
                <span className="big">
                  {selectedTask?.agent_first_name} {selectedTask?.agent_first_name}
                </span>
              </p>
              <p>
                Agent's Number: <span className="big">{selectedTask?.agent_phone}</span>
              </p>
              <p>
                Agent's Email: <span className="big">{selectedTask?.agent_email}</span>
              </p>
              <p style={{ color: 'var(--primary-color)' }}>
                Current Marketing Executive:{' '}
                <span className="big">
                  {selectedTask?.marketer?.user?.first_name} {selectedTask?.marketer?.user?.last_name}
                </span>
              </p>
            </div>
            <div>
              <p>
                Latest Call:{' '}
                <span className="big">
                  {new Date(selectedTask?.last_call).toLocaleString('en', {
                    weekday: 'long',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    month: 'short',
                    year: 'numeric',
                  })}
                </span>
              </p>
              <p>
                Status of call:{' '}
                <span className="big" style={{ color: 'var(--primary-color)' }}>
                  {' '}
                  {getCallStatus(selectedTask?.call_status)}
                </span>
              </p>
              <p>
                Call/ Schedule/ :{' '}
                <span className="big">
                  {new Date(selectedTask?.next_call).toLocaleString('en', {
                    weekday: 'long',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    month: 'short',
                    year: 'numeric',
                  })}
                </span>
              </p>
            </div>
          </div>
          <div style={{ display: 'flex' }}>
            <div className="lorem">
              <p>Comment</p>
              <p>{selectedTask?.comment}</p>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end',
                paddingBottom: '50px',
              }}>
              {selectedTask?.call_status === 'SZ' && selectedTask?.zoom_link && (
                <div
                  style={{
                    display: 'flex',
                    gap: '10px',
                    marginTop: '30px',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                  }}>
                  <span className="under">Get Meeting Link</span>
                  <a
                    href={selectedTask?.zoom_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      width: 'fit-content',
                      fontSize: '16px',
                      padding: '10px',
                      color: 'white',
                      backgroundColor: 'var(--primary-color)',
                      borderRadius: '5px',
                      cursor: 'pointer',
                      display: 'block',
                    }}>
                    Start/ Join Zoom Meeting
                  </a>
                </div>
              )}

              <span className="under" style={{ marginLeft: 'auto', marginTop: '20px' }} onClick={onOpenReassign}>
                <AiFillInfoCircle />
                Assign this meeting to another
              </span>
            </div>
          </div>
        </div>
      </Modal>

      <div className="sch">
        <div className="sheader">
          <p>Calendar</p>
          <div className="clas">
            <Zoom />
            <span>Virtual meetings</span>
            <div style={{ background: '#d1f1ff' }}></div>

            <Toggle className="toggler" icons={false} name="SZ" onChange={onFilter} checked={filters.SZ} />
          </div>
          <div className="clas">
            <Callback />
            <span>Callback</span>
            <div style={{ background: '#D2EFDA' }}></div>
            <Toggle className="toggler" icons={false} name="CB" onChange={onFilter} checked={filters.CB} />
          </div>
        </div>
        <hr />
        <div className="dates">
          {dateHolder.current.map((date, index) => (
            <div
              key={date.value}
              className={index === selectedDate ? 'active' : ''}
              onClick={() => onDateChange(index, date.value)}>
              <p>{date.display[1]}</p>
              <p>{date.display[0]}</p>
            </div>
          ))}
        </div>
        <div className="sep">
          <div>
            <p
              style={{
                fontSize: '20px',
                fontWeight: '700',
                margin: '5px 0 5px 5px',
              }}>
              Upcoming Events
            </p>
            <span
              style={{
                color: '#818181',
                marginBottom: '5px',
                marginLeft: '5px',
              }}>
              Don't miss scheduled events
            </span>
            <div className="box1">
              {tasks.map((item) => (
                <LeftBox key={item.id} {...item} />
              ))}
            </div>
          </div>
          <div className="maindays">
            <div className="spin">
              <p>Morning</p>
              <div>
                {morning.map((item) => (
                  <Card
                    key={item.id}
                    type={item.call_status}
                    time={new Date(item.next_call).toLocaleString('en', { hour: '2-digit', minute: '2-digit' })}
                    onClick={() => handleClick(item)}
                    marketer={item?.marketer?.user}
                  />
                ))}
              </div>
            </div>
            <div className="spin">
              <p className="last">Afternoon </p>
              <div>
                {afternoon.map((item) => (
                  <Card
                    key={item.id}
                    type={item.call_status}
                    time={new Date(item.next_call).toLocaleString('en', { hour: '2-digit', minute: '2-digit' })}
                    onClick={() => handleClick(item)}
                    marketer={item?.marketer?.user}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ScheduledMeetings;

const LeftBox = ({ next_call, call_status, marketer }) => {
  return (
    <div>
      <div>
        <span style={{ background: call_status === 'CB' ? '#D2EFDA' : '#d1f1ff' }}></span>
        <span>{new Date(next_call).toLocaleString('en', { hour: '2-digit', minute: '2-digit' })}</span>
      </div>
      <p>
        {marketer?.user.first_name} {marketer?.user.last_name}
      </p>
      <span>{getCallStatus(call_status)}</span>
    </div>
  );
};

const Card = ({ onClick, type, time, marketer }) => (
  <div
    style={{
      padding: '5px 20px',
      display: 'flex',
      alignItems: 'center',
      background: type === 'CB' ? '#D2EFDA' : '#D1F1FF',
      maxWidth: '300px',
      borderRadius: '5px',
      boxShadow: '-2px 2px 10px 0px #00000026',
      gap: '10px',
      cursor: 'pointer',
    }}
    onClick={onClick}>
    <div
      style={{
        width: 'fit-content',
        height: 'fit-content',
        background: 'white',
        borderRadius: '50%',
        padding: '5px',
      }}>
      {type === 'SZ' ? <Zoom /> : <Callback />}
    </div>
    <div>
      <p>
        {marketer?.first_name} {marketer?.last_name}
      </p>
      <span>{time || 'Time Frame'}</span>
    </div>
  </div>
);

const AgentItem = ({ name, onClick }) => {
  return (
    <div className="agent_card" onClick={onClick}>
      <Avatar />
      <p style={{ fontSize: 'unset' }}>{name}</p>
    </div>
  );
};
